import styled from 'styled-components';
import { arrayOf, string, func, shape } from 'prop-types';

import MenuItem from '../shared/MenuItem';
import LanguagePicker from '../shared/LanguagePicker';

import { LAPTOP_SIZE } from '../../constants';
import { withI18next } from '../../lib/withI18next';

const Container = styled.nav`
  margin-left: auto;
  @media (max-width: ${LAPTOP_SIZE}) {
    display: none;
  }
`;

const StyledList = styled.div`
  display: flex;
  align-items: center;
`;

const StyledLanguagePicker = styled(LanguagePicker)`
  margin-right: 10px;
`;

const Separator = styled.span`
  border-left: 2px solid ${({ color }) => color};
  padding: 30px 15px 2px 15px;
`;

const StyledMenu = ({
  pathname,
  options,
  toggle,
  selectedLang,
  t,
  fontColor,
}) => {
  return (
    <Container>
      <StyledList>
        <MenuItem fontColor={fontColor} href="/" pathname={pathname}>
          {t('COMPONENTS_MENU_HOME_TITLE')}
        </MenuItem>
        <MenuItem fontColor={fontColor} href="/about" pathname={pathname}>
          {t('COMPONENTS_MENU_ABOUT_TITLE')}
        </MenuItem>
        <Separator color={fontColor} />
        <StyledLanguagePicker
          color={fontColor}
          toggle={toggle}
          selectedLang={selectedLang}
        />
      </StyledList>
    </Container>
  );
};

StyledMenu.propTypes = {
  pathname: string.isRequired,
  fontColor: string.isRequired,
  toggle: func.isRequired,
  options: arrayOf(
    shape({
      value: string.isRequired,
      label: string.isRequired,
    })
  ).isRequired,
  selectedLang: shape({
    value: string.isRequired,
    label: string.isRequired,
  }).isRequired,
};

export default withI18next()(StyledMenu);



// WEBPACK FOOTER //
// components/Menu/StyledMenu.js